import { isTouchOnlyDevice } from '@/lib/util';

declare global {
  interface Window {
    touchPunchReady?: (cb?: () => void) => void;
    elmoTouchPunchReadyInstalled?: boolean;
  }
}

export function installTouchPunchReady(): void {
  if (
    typeof window === 'undefined' ||
    !isTouchOnlyDevice() ||
    window.elmoTouchPunchReadyInstalled
  ) {
    return;
  }
  window.elmoTouchPunchReadyInstalled = true;

  window.touchPunchReady = function touchPunchReady(cb?: () => void): void {
    const jq = window.jQuery;
    if (!jq?.ui) {
      cb?.();
      return;
    }
    cb?.();
  };
}
